<div class="profile">
    <div class="profile__name">{{ initials }}</div>
    <img class="profile__arrow" [src]="arrow" />
</div>
